import styled from 'styled-components';

import { Container } from '@seuk/design-system/atoms';

export interface PageHeaderProps {
  title: string;
}

export const PageHeaderContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-bottom: ${({ theme }) => theme.spacing(8)};
  }
`;

const ContentContainer = styled.div`
  position: relative;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 550px;
  }
`;

const PageTitle = styled.h1`
  ${({ theme }) => theme.typography.heading[1].normal}
`;

export const PageHeader = ({ title }: PageHeaderProps) => {
  return (
    <PageHeaderContainer>
      <Container>
        <ContentContainer>
          <PageTitle>{title}</PageTitle>
        </ContentContainer>
      </Container>
    </PageHeaderContainer>
  );
};
